import { useState } from 'react';

import { Button } from 'components/Button';
import { autoReplyMessageStrings } from 'constants/strings';
import { TAutoReplyMessageAsset } from 'api';
import { TMessageSection } from 'types';
import { AutoReplySectionsEditor } from './AutoReplySectionsEditor';
import { ChatLinkFields } from './ChatLinkFields';
import { ToggleRow } from './ToggleRow';

type Props = {
  enabled: boolean;
  sections: TMessageSection[];
  assets: TAutoReplyMessageAsset[];
  canSave: boolean;
  isSaving: boolean;
  chatLinkEnabled: boolean;
  chatLinkText: string;
  chatLinkLabel: string;
  chatLinkDisabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
  onSectionsChange: (sections: TMessageSection[]) => void;
  onChatLinkEnabledChange: (enabled: boolean) => void;
  onChatLinkTextChange: (text: string) => void;
  onChatLinkLabelChange: (label: string) => void;
  onSave: () => void;
};

export function UniformReplyTab({
  enabled,
  sections,
  assets,
  canSave,
  isSaving,
  chatLinkEnabled,
  chatLinkText,
  chatLinkLabel,
  chatLinkDisabled,
  onEnabledChange,
  onSectionsChange,
  onChatLinkEnabledChange,
  onChatLinkTextChange,
  onChatLinkLabelChange,
  onSave,
}: Props) {
  const [surveyImageUploading, setSurveyImageUploading] = useState(false);
  return (
    <div className="grid gap-5">
      <ToggleRow
        checked={enabled}
        onChange={onEnabledChange}
        label={autoReplyMessageStrings.tabs.uniform}
      />
      <ChatLinkFields
        enabled={chatLinkEnabled}
        text={chatLinkText}
        buttonLabel={chatLinkLabel}
        disabled={chatLinkDisabled}
        description={autoReplyMessageStrings.chatLink.uniformDescription}
        onEnabledChange={onChatLinkEnabledChange}
        onTextChange={onChatLinkTextChange}
        onButtonLabelChange={onChatLinkLabelChange}
      />
      <AutoReplySectionsEditor
        sections={sections}
        assets={assets}
        onChange={onSectionsChange}
        onUploadingChange={setSurveyImageUploading}
      />
      <div className="flex justify-end mx-4">
        <Button
          loading={isSaving}
          disabled={!canSave || isSaving || surveyImageUploading}
          onClick={onSave}
        >
          {autoReplyMessageStrings.save}
        </Button>
      </div>
    </div>
  );
}
